var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Basic"},[_c('main',[(_vm.main)?_c('EditableArea',{attrs:{"content":_vm.main,"id":"mainArea"}}):_vm._e()],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }